// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { updateViewHistory } from '../../apis/course';
import { updateViewHistoryActions } from '../actionCreators/updateViewHistoryActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: updateViewHistoryActions.success,
  failure: updateViewHistoryActions.failure
};

type RequestActionTypes = ActionType<
  typeof updateViewHistoryActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const updateViewHistoryEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(updateViewHistoryActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id } = action.payload;
      // send api promise
      return updateViewHistory(id)
        .then((response: any) => {
          // handle success case here
          return updateViewHistoryActions.success({
            id
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return updateViewHistoryActions.failure({ error });
        });
    })
  );
};
